module.exports = __webpack_public_path__ + "static/media/Мирзоев К., Конечная Н..cb6518e7.pdf";